import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IProductionCycle } from 'src/pages/accueil/model/types';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useProductionCycle = () => {
  const [productionCycle, setProductionCycle] = useState<IProductionCycle | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const httpClient = useHttpClient();
  const params: any = useParams();

  useEffect(() => {
    const fetchProductionCycle = async () => {
      setLoading(true);
      setError(null);
      try {
        if (params?.id) {
          const response = await httpClient.current?.get(`/api/production-cycle/${params.id}`);
          setProductionCycle(response?.data);
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch production cycle');
        setProductionCycle(null);
      } finally {
        setLoading(false);
      }
    };
    fetchProductionCycle();
  }, [httpClient, params?.id]);

  return { productionCycle, loading, error };
};
